<template>
  <el-input
    v-bind="$attrs"
    v-model="val"
    class="extra-search"
    :placeholder="placeholder"
    clearable
    @keypress.enter.stop.native="search"
    @clear="search"
  >
    <el-button
      slot="append"
      icon="el-icon-search"
      @click.stop="search"
    ></el-button>
  </el-input>
</template>
<script>
export default {
  name: 'extra-search',
  props: {
    category: String,
    value: String,
    fields: String,
    packid: String,
    version: String,
    lang: String,
    placeholder: String,
  },
  model: {
    prop: 'value',
    event: 'setval',
  },
  computed: {
    val: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('setval', newVal)
      },
    },
  },
  data() {
    return {
      delayHandle: null,
    }
  },
  methods: {
    search() {
      this.$emit('search', this.val)
      //   if (this.val) {
      //     this.$emit('search', this.val)
      //   } else {
      //     alert(
      //       (this.lang.toLowerCase() == 'cn' ? '请输入 ' : 'Please enter ') +
      //         this.placeholder
      //     )
      //   }
    },
    reset() {
      this.val = ''
    },
    delaySearch() {
      clearTimeout(this.delayHandle)
      this.delayHandle = setTimeout(() => {
        this.search()
      }, 800)
    },
  },
}
</script>
<style lang="less">
.extra-search {
}
</style>